import styled from "styled-components"
import theme from "../../../theme"

export const Button = styled.a`
  display: inline-flex;
  cursor: pointer;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  user-select: none;
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.text.reverse};
  text-decoration: none;
  padding: 12px 24px 12px;
  background: ${theme.brand.default};
  border-radius: 25px;
  border-color: transparent;
  outline: none;
  opacity: .9;
  align-items: center;
  
  &:focus{
    outline:none;
  }
  
  &:hover{
    opacity: 1;
  }
  
    
  @media (min-width: 1024px) {
    font-size: 0.85rem;
  }
  
  & > .icon{
    margin-right: 8px;
  }
`
